import { ibasePath } from "@/shop/components/Ibase/config";
import { customerContractsPath } from "@/shop/components/PersonalizedArea/RoutesConfig";

interface ILocalizedRoute {
  /** preliminary path (used as fallback if no translationKey is provided) */
  path: string;
  /** i18n key to translate the route */
  i18nKey?: string;
}

interface IbaseRoutingStructure {
  basePath: ILocalizedRoute;
}

interface IPersonalizedAreaRoutingStructure extends IbaseRoutingStructure {
  contracts: ILocalizedRoute;
  customerContracts: ILocalizedRoute;
  ibasePath: ILocalizedRoute;
  orderHistory: ILocalizedRoute;
  originalSupply: ILocalizedRoute;
  quoteHistory: ILocalizedRoute;
  searchInMachine: ILocalizedRoute;
  searchInStructure: ILocalizedRoute;
}

const personalizedAreaLocationRouting: IPersonalizedAreaRoutingStructure = {
  basePath: { path: "/personalized-area", i18nKey: "app:navigation.personalized-br-area" },
  contracts: { path: "/contracts", i18nKey: "app:navigation.contracts" },
  customerContracts: { path: customerContractsPath, i18nKey: "app:navigation.user contracts" },
  ibasePath: { path: ibasePath, i18nKey: "app:navigation.ibase" },
  originalSupply: { path: "/original-supply", i18nKey: "app:navigation.originalSupply" },
  orderHistory: { path: "/order-history", i18nKey: "app:navigation.orders" },
  quoteHistory: { path: "/quote-history", i18nKey: "app:navigation.quotes" },
  searchInMachine: { path: "/search-in-machine", i18nKey: "" },
  searchInStructure: { path: "/search-in-structure", i18nKey: "" }
};

/**
 * Why was this every in the redux state?
 * @returns
 */
export const getPersonalizedAreaRoutingStructure = (): IPersonalizedAreaRoutingStructure => personalizedAreaLocationRouting;
